{
  "tabs": {
    "users": "Users",
    "pics": "Pics",
    "lotNames": "Lot Descriptions"
  },
  "users": {
    "userList": "User List",
    "email": "Email",
    "name": "Name",
    "assignments": "Assignments",
    "createdAt": "Created At",
    "pics": "PICs",
    "farmerNames": "Farmer Names",
    "invite": "Invite",
    "edit": "Edit",
    "updateAssignments": "Update Assignments",
    "assignPics": "Assign PICs",
    "assignFarmerNames": "Assign Farmer Names",
    "delete": "Delete",
    "inviteNewUser": "Invite a new user",
    "emailUsername": "Email (This will act as username)",
    "firstName": "First Name",
    "lastName": "Last Name",
    "role": "Role",
    "businessName": "Business Name",
    "assignLotsToPics": "Assign Lots to PICs",
    "lotsHelperText": "Please separate multiple lots with comma. Type only the keyword \"All\" if you prefer to assign all lots of a PIC.",
    "submit": "Submit",
    "cancel": "Cancel",
    "notAllowedAdmin": "This user is not allowed to be admin",
    "updateUser": "Update {{displayName}}",
    "confirmDelete": "Confirm to delete {{displayName}}",
    "confirmDeleteMessage": "Are you sure you want to delete {{displayName}}?",
    "activeBookingsWarning_one": "{{displayName}} still has {{count}} active booking. Delete or reassign their bookings first.",
    "activeBookingsWarning_other": "{{displayName}} still has {{count}} active bookings. Delete or reassign their bookings first.",
    "updateAssignmentsOf": "Update Assignments of {{displayName}}",
    "assignPicsTo": "Assign PICs to {{displayName}}",
    "assignFarmerNamesTo": "Assign Farmer Names to {{displayName}}",
    "assignment": {
      "location": "Location",
      "locationPlaceholder": "Pick a location",
      "noLocations": "No location you can assign at",
      "capability": "Capability",
      "capabilities": {
        "user": "User",
        "admin": "Admin"
      },
      "persona": "Persona",
      "personaPlaceholder": "No persona",
      "forbidden": "You can only change people who hold an assignment at a location you administer."
    }
  },
  "lotNames": {
    "title": "Lot Descriptions",
    "lotReference": "Lot",
    "killDate": "Kill Date",
    "name": "Description",
    "updatedAt": "Updated At",
    "add": "Add",
    "edit": "Edit",
    "delete": "Delete",
    "editName": "Edit Lot Description",
    "selectLot": "Select a Lot",
    "update": "Update",
    "reset": "Reset",
    "cancel": "Cancel"
  }
}
